import { Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { EditorModalType } from "./ComponentEditorContext";
import { useModalEditorDisplayContext } from "./ModalEditorContext";
import { usePathContext } from "./PathInfo";

interface OpenFilterButtonProps {
  propName: string;
  value: object;
}

export function OpenFilterEditorButton(props: OpenFilterButtonProps) {
  const { showModal, setModalContext } = useModalEditorDisplayContext();
  const { path } = usePathContext();

  const handleOpenFilterEditor = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setModalContext(path, props.value, EditorModalType.filterEditor);
      showModal();
    },
    [setModalContext, props.value, path, showModal],
  );

  return (
    <>
      <Typography component={"span"}>{props.propName}: </Typography>
      <Button variant="outlined" onClick={(event) => handleOpenFilterEditor(event)}>
        Edit filter
      </Button>
    </>
  );
}
